import { ComputedRef } from 'vue'

import { User } from '@/domain/entities/user/user'
import { UserRegistrationRequest } from '@/domain/entities/user/userCreateRequest'
import { AuthStateViewModel } from '@/presentation/viewmodels/auth/authStateViewModel'

export class AuthStatePresenter {
  private viewModel: AuthStateViewModel

  constructor(viewModel: AuthStateViewModel) {
    this.viewModel = viewModel
  }

  get user(): ComputedRef<User> {
    return this.viewModel.user
  }

  get isLogin(): ComputedRef<boolean> {
    return this.viewModel.isLogin
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<Error | null> {
    return this.viewModel.error
  }

  checkSession(): void {
    this.viewModel.checkSession()
  }

  login(id: string, password: string): Promise<boolean> {
    return this.viewModel.login(id, password)
  }

  logout(): void {
    this.viewModel.logout()
  }

  async registerUser(user: UserRegistrationRequest): Promise<void> {
    await this.viewModel.registerUser(user)
  }
}
